import { computed } from 'vue'
import { useStore } from 'vuex'
import { checkHasToCreateMspAccount, triggerAddAccountEvent } from '@/StoreWeb/js/composables/msp-account-utils'
import emitter from 'global-emitter'
import * as catalogMutationTypes from '@/StoreWeb/store/modules/catalog/mutation-types'
import { isEmpty } from 'global-utils'
import { useLogin } from '@/StoreWeb/js/composables/login-utils'
import addCartFlowMixins from '@/StoreWeb/js/mixins/add-cart-flow-utils'
import { useI18n } from 'vue-i18n'

export const useAddToCart = () => {
    const store = useStore()
    const { t } = useI18n()
    const { storeAddCartFlow, triggerLogin } = addCartFlowMixins()
    const { isAuthenticated } = useLogin()

    const getHasSelectedFareMedia = computed(() => selectedFareMedia.value && !isEmpty(selectedFareMedia.value) && selectedFareMedia.value.id !== undefined)
    const getUserStatus = computed(() => store.getters.getUserStatus)
    const isMobileApp = computed(() => store.state.isMobileApp)
    const productDetails = computed(() => store.state.catalogModule.productDetails)
    const selectedFareMedia = computed(() => store.state.userModule.selectedFareMedia)
    const showAddToCart = computed(() => {
        return productDetails.value.saleableUnit.id !== 'NON_SALEABLE' &&
            (
                getHasSelectedFareMedia.value !== true ||
                (
                    getHasSelectedFareMedia.value === true &&
                    productDetails.value.requiredFareProfiles.length === 0
                )
            )
    })
    const showAddToCartForMobileApp = computed(() => isMobileApp.value && showAddToCart.value)
    const showAddToCartForWebApp = computed(() => !isMobileApp.value && showAddToCart.value)
    const userPendingRequests = computed(() => store.state.userModule.userPendingRequests)

    function addCartAction () {
        if (isAuthenticated.value) {
            const { hasToCreateMspAccount, provider } = checkHasToCreateMspAccount(productDetails.value)

            if (!userPendingRequests.value.getWallet && getUserStatus.value === 'BLOCKED_PAYMENT_REQUIRED') {
                emitter.emit('showAlertModal', {
                    messageHTML: t('wallet:blocked_payment_required:message'),
                    title: t('wallet:blocked_payment_required:title')
                })

                return
            }

            if (hasToCreateMspAccount) {
                store.commit(catalogMutationTypes.SET_PRODUCT_TO_ADD_ONCE_ACCOUNT_FINALIZED, productDetails.value)
                triggerAddAccountEvent(provider)

                return
            }

            emitter.emit('showProductModal', productDetails.value)

            return
        }

        if ((productDetails.value.modalType === 'MODALPRODUCT' || productDetails.value.modalType === 'MODALPRODUCTGROUP') && !isEmpty(productDetails.value.getUserAuthModes())) {
            if (productDetails.value.hasToLoginOnAddToCart()) {
                storeAddCartFlow({
                    mode: 'PRODUCT_DETAILS',
                    product: productDetails.value
                })
            }

            emitter.emit('showProductModal', productDetails.value)

            return
        }

        storeAddCartFlow({
            mode: 'PRODUCT_DETAILS',
            product: productDetails.value
        })

        triggerLogin({
            callback: emitter.emit('hideProductModal', { keep: true })
        })
    }

    return {
        addCartAction,
        productDetails,
        selectedFareMedia,
        showAddToCart,
        showAddToCartForMobileApp,
        showAddToCartForWebApp
    }
}
